import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-63">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-64">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[85vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-65">
            <div className="flex items-center justify-between px-8 py-5 border-b border-sage-100 bg-sage-50" data-id="element-66">
              <h2 className="text-2xl font-serif font-bold text-sage-900" data-id="element-67">
                {title}
              </h2>
              <button onClick={onClose} className="p-2 rounded-full hover:bg-sage-200 transition-colors text-sage-600" aria-label="Cerrar" data-id="element-68">
                <XIcon className="w-6 h-6" data-id="element-69" />
              </button>
            </div>
            <div className="px-8 py-6 overflow-y-auto text-sage-700 leading-relaxed space-y-4 text-base" data-id="element-70">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}